/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meetings_Exception_Person_LabelInputs */



/**
* | output |
* | --- |
* | "Email address" |
*
* @param {Meetings_Exception_Person_LabelInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meetings_exception_person_label = /** @type {((inputs?: Meetings_Exception_Person_LabelInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meetings_Exception_Person_LabelInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("E-mailadres")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Adresse e-mail")
	return /** @type {LocalizedString} */ ("Email address")
});